import React from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Delete, Warning } from "@mui/icons-material";

const LearningRecordDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  record,
  isDeleting = false,
}) => {
  const learningId = record?.learning_id || record?.id || record?._id || record?.uuid || "N/A";
  const learningType = record?.learning_type || record?.type || record?.store || "N/A";
  const namespace = record?.namespace || record?.namespace_key || "N/A";

  return (
    <Dialog
      open={open}
      onClose={isDeleting ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Warning color="error" />
        Delete Learning Record
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Are you sure you want to delete this learning record?
        </Typography>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <Typography variant="body2">
            <strong>Warning:</strong> This action permanently deletes the selected learning record.
            This action cannot be undone.
          </Typography>
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          <strong>ID:</strong> {learningId}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
          <strong>Type:</strong> {learningType}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>Namespace:</strong> {namespace}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={16} /> : <Delete />}
        >
          {isDeleting ? "Deleting..." : "Delete Record"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LearningRecordDeleteDialog;
